<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Documentos de Recepcion de mercancias</ModuleHeader>
      <v-card flat class="my-4">
        <v-card-text>
          <v-row class="justify-center">
            <v-col md="4" cols="12" class="input">
              <label>Fecha inicial</label>
              <Datepicker
                @selected="selectDate"
                :value="input_date.format('MM/DD/YYYY')"
              ></Datepicker>
            </v-col>
            <v-col md="4" cols="12" class="input">
              <label>Fecha final</label>
              <Datepicker
                @selected="selectDateFinal"
                :disabled-dates="disableDates"
                :value="input_date_final.format('MM/DD/YYYY')"
              ></Datepicker>
            </v-col>
            <v-col md="4" cols="12" class="input">
              <v-btn block color="success" @click="getDocuments()"
                >Buscar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
        @buttonOptClick="optButtonClick"
      ></uv-data-table>
    </div>

    <modal v-model="showModal" :showFooter="false" title="Agregar Categoria">
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import Datepicker from "vuejs-datepicker";

export default {
  name: "DocumentosCRUD",
  components: {
    modal,
    Datepicker,
    uvDataTable,
  },

  props: [],
  data() {
    return {
      origenes: [],
      self: this,
      showModal: false,
      formKey: 0,
      Documentos: [],
      formIndex: 0,
      editMode: false,
      showCreator: false,
      creatorIndex: 0,
      editData: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva Recepción de Mercancias",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Abrir documento",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },
        ],
        fields: [
          {
            text: "Documento de mercancias",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
          },
          /*{
            text: "Departamento",
            value: "Departamento",
          },*/
          {
            text: "Origen Inv.",
            value: "origenNombre",
            canBeFiltered: true,
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["Status"] == "Completado") {
                return '<b style="color:green;">' + row["Status"] + "</b>";
              } else {
                return '<b style="color:orange;">' + row["Status"] + "</b>";
              }
            },
          },
        ],
      },
      input_date: moment(),
      input_date_final: moment(),
    };
  },
  methods: {
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        //this.createDocument();
        this.$router.push({
          path: "/productos-inventarios/documentoRecepcion",
        });
      }
      if (buttonId == "editDocumentRecepcion") {
        this.$router.push({
          path: "/productos-inventarios/documentoRecepcion/" + idSelected,
        });
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    async createDocument() {
      this.$swal({
        title: "¿Deseas crear un nuevo documento de recepción de mercancias?",
        text: "Al crear el documento podras agregar los productos necesarios para ingresar a inventario",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Crear Documento",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento Creado",
              "El documento se creo correctamente",
              "success"
            );
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.id,
            });
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        alert("Creando");
        this.$pgsHelper.log(data);
      } else if (doAction == "EDIT") {
        alert("editando");
        this.$pgsHelper.log(data);
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      if (docu.Aplicado) {
        this.$swal(
          "No puedes eliminar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas el documento de entrada de mercancias?",
        text: "Al eliminarlo se perderan todos los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-eliminarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_RECEPCION_DELETE",
              Mensaje: `Documento de recepción eliminado: ${datos.Id}`,
              reference: { id: datos.Id, tp: "INV-RecepcionMercancia", al: "RECEPCION INVENTARIO" },
              data: docu || datos
            });
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getDocuments() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );

      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Prod_EntSal", [
        firestore.where("TipoMovimiento", "==", "Entrada"),
        
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        // firestore.where("FechaCreacion", ">=", startDate),
        // firestore.where("FechaCreacion", "<", end),
        
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        /* let dateFormat = new firestore.Timestamp(
          data.FechaCreacion.seconds,
          data.FechaCreacion.nanoseconds
        );*/
        let fecha = new moment(data.FechaCreacion);
        let origenData = this.getOrigenById(data.Origen);
        this.Documentos.push({
          id: data.id,
          origenId: origenData.id,
          origenNombre: origenData.Nombre,
          Nombre: "Documento-" + data.id,
          Fecha: fecha.format("YYYY-MM-DD HH:mm"),
          Departamento: data.Departamentos[0],
          Aplicado: data.Aplicado,
          Status: data.Aplicado ? "Completado" : "Pendiente",
        });
      });

      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
      // this.getDocuments();
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
  },
  watch: {},
  mounted() {},
  async created() {
    await this.getOrigenes();
    //await this.getDocuments();
  },
};
</script>
